import { createContext, useContext, useLayoutEffect, useState } from "react";
//#region src/ui/menu/context.tsx
const MenuContext = createContext(null);
const MenuContextProvider = MenuContext.Provider;
/** Returns the current menu compound-component context. Throws outside `Menu.Root`. */
function useMenuContext() {
	const ctx = useContext(MenuContext);
	if (!ctx) throw new Error("Menu compound components must be used within a Menu.Root");
	return ctx;
}
/** Returns the nearest menu context, or `null` outside `Menu.Root`. */
function useOptionalMenuContext() {
	return useContext(MenuContext);
}
/** Publishes a specialized option group's selected value and availability to its enclosing menu. */
function useMenuOptionState(state) {
	const setOptionState = useOptionalMenuContext()?.setOptionState;
	const [source] = useState(() => Symbol("menu-option"));
	const { value, disabled, hidden, availability } = state;
	useLayoutEffect(() => {
		if (!setOptionState) return void 0;
		setOptionState(source, {
			value,
			disabled,
			hidden,
			availability
		});
		return () => setOptionState(source, null);
	}, [
		availability,
		disabled,
		hidden,
		setOptionState,
		source,
		value
	]);
}
const MenuPopupContext = createContext(null);
const MenuPopupContextProvider = MenuPopupContext.Provider;
function useMenuPopupContext() {
	const ctx = useContext(MenuPopupContext);
	if (!ctx) throw new Error("Menu.Content must be used within a Menu.Popup");
	return ctx;
}
const MenuGroupContext = createContext(null);
const MenuGroupContextProvider = MenuGroupContext.Provider;
function useMenuGroupContext() {
	return useContext(MenuGroupContext);
}
const MenuRadioGroupContext = createContext(null);
const MenuRadioGroupContextProvider = MenuRadioGroupContext.Provider;
function useMenuRadioGroupContext() {
	const ctx = useContext(MenuRadioGroupContext);
	if (!ctx) throw new Error("Menu.RadioItem must be used within a Menu.RadioGroup");
	return ctx;
}
const MenuRadioItemContext = createContext(false);
const MenuRadioItemContextProvider = MenuRadioItemContext.Provider;
function useOptionalMenuRadioItemContext() {
	return useContext(MenuRadioItemContext);
}
const MenuTriggerChildContext = createContext(false);
const MenuTriggerChildContextProvider = MenuTriggerChildContext.Provider;
function useOptionalMenuTriggerChildContext() {
	return useContext(MenuTriggerChildContext);
}
//#endregion
export { MenuContextProvider, MenuGroupContextProvider, MenuPopupContextProvider, MenuRadioGroupContextProvider, MenuRadioItemContextProvider, MenuTriggerChildContextProvider, useMenuContext, useMenuGroupContext, useMenuOptionState, useMenuPopupContext, useMenuRadioGroupContext, useOptionalMenuContext, useOptionalMenuRadioItemContext, useOptionalMenuTriggerChildContext };

//# sourceMappingURL=context.js.map